// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * The supplier portal shell: a top bar, a left menu on tablets and desktops and a bottom tab bar on phones.
 * Same tokens as the vendor shell (Layout.css): page #f2f5fa, borders #e3ebf8, brand #C9194A.
 * data-shell comes from hooks/useViewport.js, so this CSS and the JS never disagree about the layout.
 */
.supplier-shell {
  --sup-bar-h: 60px;
  --sup-side-w: 208px;
  --sup-bottom-h: 64px;
  min-height: 100vh;
  background: #f2f5fa;
  padding-left: env(safe-area-inset-left, 0px);
  padding-right: env(safe-area-inset-right, 0px);
}
.supplier-shell[data-shell="phone"] {
  --sup-bar-h: 56px;
}
.supplier-bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: var(--sup-bar-h);
  background: #fff;
  border-bottom: 1px solid #e3ebf8;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 0 16px;
  z-index: 1030;
}
.supplier-bar .supplier-tag {
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  border-left: 1px solid #e3ebf8;
  padding-left: 12px;
  white-space: nowrap;
}
.supplier-bar .supplier-spacer {
  flex: 1 1;
}
.supplier-side {
  position: fixed;
  top: var(--sup-bar-h);
  left: 0;
  bottom: 0;
  width: var(--sup-side-w);
  background: #fff;
  border-right: 1px solid #e3ebf8;
  padding: 12px 8px;
  overflow-y: auto;
  z-index: 1020;
}
.supplier-side a,
.supplier-bottom a {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 8px;
  color: #374151;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  min-height: 40px;
}
.supplier-side a:hover {
  background: #f9fafb;
}
.supplier-side a.active,
.supplier-bottom a.active {
  background: #fdf2f5;
  color: #c9194a;
  font-weight: 600;
}
.supplier-main {
  padding: calc(var(--sup-bar-h) + 16px) 16px 16px calc(var(--sup-side-w) + 16px);
}
.supplier-shell[data-shell="phone"] .supplier-main {
  padding: calc(var(--sup-bar-h) + 12px) 12px calc(var(--sup-bottom-h) + env(safe-area-inset-bottom, 0px) + 16px) 12px;
}
.supplier-bottom {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  height: calc(var(--sup-bottom-h) + env(safe-area-inset-bottom, 0px));
  padding-bottom: env(safe-area-inset-bottom, 0px);
  background: #fff;
  border-top: 1px solid #e3ebf8;
  display: flex;
  justify-content: space-around;
  z-index: 1030;
}
.supplier-bottom a {
  flex-direction: column;
  gap: 2px;
  font-size: 11px;
  flex: 1 1;
  justify-content: center;
  border-radius: 0;
}
.supplier-bell-panel {
  position: fixed;
  top: var(--sup-bar-h);
  right: 0;
  width: min(420px, 100vw);
  max-height: calc(100dvh - var(--sup-bar-h));
  background: #fff;
  border-left: 1px solid #e3ebf8;
  border-bottom: 1px solid #e3ebf8;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  z-index: 2000;
  overflow-y: auto;
  padding: 16px;
}

/* Six entries fit a 360px phone: tight padding, labels that cut off instead of wrapping, the unread count floating on its icon. */
.supplier-bottom a {
  position: relative;
  padding: 8px 2px;
  min-width: 0;
}
.supplier-bottom a > span:not(.supplier-badge) {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.supplier-badge {
  background: #c9194a;
  color: #fff;
  border-radius: 10px;
  padding: 0 6px;
  font-size: 11px;
  line-height: 16px;
  margin-left: auto;
}
.supplier-bottom .supplier-badge {
  position: absolute;
  top: 4px;
  left: calc(50% + 6px);
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Supplier/SupplierLayout.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,4CAA4C;EAC5C,8CAA8C;AAChD;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,wBAAwB;EACxB,gBAAgB;EAChB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,aAAa;AACf;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,SAAO;AACT;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,OAAO;EACP,SAAS;EACT,wBAAwB;EACxB,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;AACA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,+EAA+E;AACjF;AACA;EACE,oHAAoH;AACtH;AACA;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oEAAoE;EACpE,gDAAgD;EAChD,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EACb,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,SAAO;EACP,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,QAAQ;EACR,wBAAwB;EACxB,2CAA2C;EAC3C,gBAAgB;EAChB,8BAA8B;EAC9B,gCAAgC;EAChC,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,aAAa;AACf;;AAEA,kIAAkI;AAClI;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,qBAAqB;EACrB,SAAS;AACX","sourcesContent":["/*\n * The supplier portal shell: a top bar, a left menu on tablets and desktops and a bottom tab bar on phones.\n * Same tokens as the vendor shell (Layout.css): page #f2f5fa, borders #e3ebf8, brand #C9194A.\n * data-shell comes from hooks/useViewport.js, so this CSS and the JS never disagree about the layout.\n */\n.supplier-shell {\n  --sup-bar-h: 60px;\n  --sup-side-w: 208px;\n  --sup-bottom-h: 64px;\n  min-height: 100vh;\n  background: #f2f5fa;\n  padding-left: env(safe-area-inset-left, 0px);\n  padding-right: env(safe-area-inset-right, 0px);\n}\n.supplier-shell[data-shell=\"phone\"] {\n  --sup-bar-h: 56px;\n}\n.supplier-bar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: var(--sup-bar-h);\n  background: #fff;\n  border-bottom: 1px solid #e3ebf8;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 0 16px;\n  z-index: 1030;\n}\n.supplier-bar .supplier-tag {\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n  border-left: 1px solid #e3ebf8;\n  padding-left: 12px;\n  white-space: nowrap;\n}\n.supplier-bar .supplier-spacer {\n  flex: 1;\n}\n.supplier-side {\n  position: fixed;\n  top: var(--sup-bar-h);\n  left: 0;\n  bottom: 0;\n  width: var(--sup-side-w);\n  background: #fff;\n  border-right: 1px solid #e3ebf8;\n  padding: 12px 8px;\n  overflow-y: auto;\n  z-index: 1020;\n}\n.supplier-side a,\n.supplier-bottom a {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 12px;\n  border-radius: 8px;\n  color: #374151;\n  font-size: 14px;\n  font-weight: 500;\n  text-decoration: none;\n  min-height: 40px;\n}\n.supplier-side a:hover {\n  background: #f9fafb;\n}\n.supplier-side a.active,\n.supplier-bottom a.active {\n  background: #fdf2f5;\n  color: #c9194a;\n  font-weight: 600;\n}\n.supplier-main {\n  padding: calc(var(--sup-bar-h) + 16px) 16px 16px calc(var(--sup-side-w) + 16px);\n}\n.supplier-shell[data-shell=\"phone\"] .supplier-main {\n  padding: calc(var(--sup-bar-h) + 12px) 12px calc(var(--sup-bottom-h) + env(safe-area-inset-bottom, 0px) + 16px) 12px;\n}\n.supplier-bottom {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: calc(var(--sup-bottom-h) + env(safe-area-inset-bottom, 0px));\n  padding-bottom: env(safe-area-inset-bottom, 0px);\n  background: #fff;\n  border-top: 1px solid #e3ebf8;\n  display: flex;\n  justify-content: space-around;\n  z-index: 1030;\n}\n.supplier-bottom a {\n  flex-direction: column;\n  gap: 2px;\n  font-size: 11px;\n  flex: 1;\n  justify-content: center;\n  border-radius: 0;\n}\n.supplier-bell-panel {\n  position: fixed;\n  top: var(--sup-bar-h);\n  right: 0;\n  width: min(420px, 100vw);\n  max-height: calc(100dvh - var(--sup-bar-h));\n  background: #fff;\n  border-left: 1px solid #e3ebf8;\n  border-bottom: 1px solid #e3ebf8;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  z-index: 2000;\n  overflow-y: auto;\n  padding: 16px;\n}\n\n/* Six entries fit a 360px phone: tight padding, labels that cut off instead of wrapping, the unread count floating on its icon. */\n.supplier-bottom a {\n  position: relative;\n  padding: 8px 2px;\n  min-width: 0;\n}\n.supplier-bottom a > span:not(.supplier-badge) {\n  max-width: 100%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.supplier-badge {\n  background: #c9194a;\n  color: #fff;\n  border-radius: 10px;\n  padding: 0 6px;\n  font-size: 11px;\n  line-height: 16px;\n  margin-left: auto;\n}\n.supplier-bottom .supplier-badge {\n  position: absolute;\n  top: 4px;\n  left: calc(50% + 6px);\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
